import {
  ApiClientFactory
} from '../ApiClientFactory';
import {
  API_URL
} from '../Variables';

let clientFactory = new ApiClientFactory();

export const ForumClient = {
  /**
   *
   * Returns a forum with a given id
   */
  getForums(group_id) {
    return clientFactory.get(API_URL + 'forums', {
      params: {
        group_id: group_id
      }
    });
  },
  getForum(id) {
    return clientFactory.get(API_URL + 'forums/' + id);
  },
  getTopic(forumId, topicId) {
    return clientFactory.get(API_URL + 'forums/' + forumId + '/topics/' + topicId)
  },
  getPost(forumId, topicId, postId) {
    return clientFactory.get(API_URL + 'forums/' + forumId + '/topics/' + topicId + '/posts/' + postId)
  },
  /**
   *
   * Creates a new forum
   */
  createForum() {
    return clientFactory.post(API_URL + 'forums');
  },
  createComment(forumId, topicId, postId, body) {
    return clientFactory.post(API_URL + 'forums/' + forumId + '/topics/' + topicId + '/posts/' + postId + '/comments', {
      body: body
    })
  },
  createReplyComment(forumId, topicId, postId, parent_id, body) {
    return clientFactory.post(API_URL + 'forums/' + forumId + '/topics/' + topicId + '/posts/' + postId + '/comments/' + parent_id, {
      body: body
    })
  },
  deleteComment(commentId) {
    return clientFactory.delete(API_URL + 'comments/' + commentId)
  },
  deletePost(postId) {
    return clientFactory.delete(API_URL + 'forums/' + 'posts/' + postId)
  },
  createPost(payload) {
    return clientFactory.post(API_URL + 'forums/topics/posts', {
      content: payload.content,
      title: payload.title,
      forum_topic_id: payload.topicId,
      user_id: payload.userId,
      document_id: null
    })
  },
  // $post->content = $request->input('content');
  // 	$post->title = $request->input('title');
  // 	$post->user_id = $request->input('user_id');
  // 	$post->forum_topic_id = $request->input('forum_topic_id');
  // 	$post->document_id = $request->input('document_id') ?? null;
  /**
   *
   * Add a post to a topic
   */
  addPost(payload) {
    return clientFactory.post(API_URL + 'forums/topics/posts', {
      content: payload.document.forum_post.content,
      title: payload.document.forum_post.title,
      forum_topic_id: payload.document.forum_post.forum_topic_id,
      user_id: payload.user.id,
      document_id: payload.document.id,
    });
  },
};